import { run, hasSufficientPerformance, hasSufficientDownloadPerformance, setup } from '#booster/utils/performance';
import { isSupportedBrowser } from '#booster/utils/browser';

let initialized = false
const layerEl = window.document.getElementById('nuxt-booster-layer');

const forceInit = ('__NUXT_BOOSTER_FORCE_INIT__' in window && window.__NUXT_BOOSTER_FORCE_INIT__);

const triggerRunCallback = sufficient => window.dispatchEvent(new CustomEvent('nuxt-booster:run', { detail: { sufficient } }))

async function initApp(force) {
  if (initialized) {
    return;
  }

  document.documentElement.classList.remove('nuxt-booster-reduced-view');

  try {
    if (!force) {
      await run();
    }

    initialized = true;

    triggerRunCallback(true);

    return import('../client');
  } catch (error) {
    triggerRunCallback(false);

    if (!!layerEl) {
      // User must interact via the layer.
      updateBoosterLayerMessage('nuxt-booster-message-weak-hardware');
      return null;
    }
  }

  return null;
};

function observeBoosterButton (id, callback) {
  Array.from(document.querySelectorAll(`#${id}`)).forEach(el => {
    el.addEventListener('click', callback, { capture: true, once: true, passive: true })
  })
}

function updateBoosterLayerMessage(id) {
  const el = window.document.getElementById(id)
  if (!el) {
    throw new Error(`Can\'t update booster-layer, message ${id} missing.`);
  } else {
    el.style.display = 'block'
    layerEl.className += ' nuxt-booster-layer-visible';
  }
}

function initReducedView () {
  document.documentElement.classList.add('nuxt-booster-reduced-view');

  // activate fonts
  window.document.querySelectorAll('[data-font]').forEach((node) => {
    node.classList.add('font-active');
  })

  // transform noscript>picture to picture
  Array.from(document.querySelectorAll('noscript.nuxt-booster-picture-noscript')).forEach(el => {
    const tmp = document.createElement('div');
    tmp.innerHTML = el.innerHTML;
    el.parentNode.replaceChild(tmp.children[0], el);
    tmp.remove();
  })
}

function setupBoosterLayer(supportedBrowser) {
  if(!supportedBrowser) {
    updateBoosterLayerMessage('nuxt-booster-message-unsupported-browser');
  }
  if(!hasSufficientDownloadPerformance()) {
    updateBoosterLayerMessage('nuxt-booster-message-reduced-bandwidth');
  }
}

const supportedBrowser = isSupportedBrowser({regex: new RegExp("Trident\u005C\u002F[78]\u005C.0|Edge?\u005C\u002F(9[7-9]|\u005Cd{3,})\u005C.\u005Cd+(\u005C.\u005Cd+|)|Firefox\u005C\u002F(9[1-9]|\u005Cd{3,})\u005C.\u005Cd+(\u005C.\u005Cd+|)|Chrom(ium|e)\u005C\u002F(9[6-9]|\u005Cd{3,})\u005C.\u005Cd+(\u005C.\u005Cd+|)|(Maci|X1{2}).+ Version\u005C\u002F(14\u005C.([1-9]|\u005Cd{2,})|(1[5-9]|[2-9]\u005Cd|\u005Cd{3,})\u005C.\u005Cd+)([,.]\u005Cd+|)( \u005C(\u005Cw+\u005C)|)( Mobile\u005C\u002F\u005Cw+|) Safari\u005C\u002F|Chrome.+OPR\u005C\u002F(8[2-9]|9\u005Cd|\u005Cd{3,})\u005C.\u005Cd+\u005C.\u005Cd+|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(12[._]([2-9]|\u005Cd{2,})|(1[3-9]|[2-9]\u005Cd|\u005Cd{3,})[._]\u005Cd+)([._]\u005Cd+|)|Opera Mini|Android:?[ \u002F-](9[89]|\u005Cd{3,})(\u005C.\u005Cd+|)(\u005C.\u005Cd+|)|Mobile Safari.+OPR\u005C\u002F(6[4-9]|[7-9]\u005Cd|\u005Cd{3,})\u005C.\u005Cd+\u005C.\u005Cd+|Android.+Firefox\u005C\u002F(9[6-9]|\u005Cd{3,})\u005C.\u005Cd+(\u005C.\u005Cd+|)|Android.+Chrom(ium|e)\u005C\u002F(9[89]|\u005Cd{3,})\u005C.\u005Cd+(\u005C.\u005Cd+|)|Android.+(UC? ?Browser|UCWEB|U3)[ \u002F]?(12\u005C.(1[2-9]|[2-9]\u005Cd|\u005Cd{3,})|(1[3-9]|[2-9]\u005Cd|\u005Cd{3,})\u005C.\u005Cd+)\u005C.\u005Cd+|SamsungBrowser\u005C\u002F(1[5-9]|[2-9]\u005Cd|\u005Cd{3,})\u005C.\u005Cd+|Android.+MQ{2}Browser\u005C\u002F(10(\u005C.([4-9]|\u005Cd{2,})|)|(1[1-9]|[2-9]\u005Cd|\u005Cd{3,})(\u005C.\u005Cd+|))(\u005C.\u005Cd+|)|baidubrowser[\u005Cs\u002F](7(\u005C.(1[2-9]|[2-9]\u005Cd|\u005Cd{3,})|)|([89]|\u005Cd{2,})(\u005C.\u005Cd+|))(\u005C.\u005Cd+|)|K[Aa][Ii]OS\u005C\u002F(2\u005C.([5-9]|\u005Cd{2,})|([3-9]|\u005Cd{2,})\u005C.\u005Cd+)(\u005C.\u005Cd+|)", "")});

window.addEventListener('load', function () {
  if (!document.getElementById('nuxt-booster-layer')) {
    initApp(forceInit);
  } else {
    observeBoosterButton('nuxt-booster-button-init-reduced-view', initReducedView);
    observeBoosterButton('nuxt-booster-button-init-app', () => initApp(true));

    setup({"timing":{"fcp":800,"dcl":1200},"device":{"hardwareConcurrency":{"min":2,"max":48},"deviceMemory":{"min":1}}});

    if(('__NUXT_BOOSTER_AUTO_INIT__' in window && window.__NUXT_BOOSTER_AUTO_INIT__) || ((true && hasSufficientPerformance()) && supportedBrowser)) {
      initApp();
    } else {
      setupBoosterLayer(supportedBrowser)
    }
  }
});
